import React from 'react';
import { motion } from 'framer-motion';

interface AcsSectionProps {
  title: string;
  content: string;
  image: string;
}

export function AcsSection({ title, content, image }: AcsSectionProps) {
  return (
    <section className="py-12 sm:py-20 bg-white dark:bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-8 sm:gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="max-w-xl"
          >
            <img
              src="https://pvtistes.net/wp-content/themes/pvtistest-2/static/images/acs/logo.png"
              alt="ACS"
              className="h-10 sm:h-12 w-auto mb-6"
            />
            <h2 className="text-xl sm:text-3xl font-bold text-gray-900 dark:text-white mb-4">
              Votre partenaire assurance depuis plus de 40 ans
            </h2>
            <div className="space-y-3 text-sm sm:text-base text-gray-600 dark:text-gray-400 leading-relaxed">
              <p>Decouvrez l'assurance Globe PVT proposee par notre partenaire exclusif ACS - Assurances voyage & expatriation.</p>
              <p>Specialiste de la mobilite internationale, ACS accompagne au plus pres voyageurs et expatries aux 4 coins du monde.</p>
              <p>Chaque annee, plus de 100 000 personnes font confiance a ACS pour une couverture optimale et un excellent rapport qualite-prix.</p>
            </div>
            <p className="mt-4 text-xs text-gray-400 dark:text-gray-500 italic">
              Cette page, ainsi que toutes les informations relatives a l'assurance, sont redigees sous la responsabilite exclusive d'ACS, societe de courtage d'assurance.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
            className="relative overflow-hidden rounded-2xl"
          >
            <div className="absolute inset-0 bg-gradient-to-br from-emerald-100 via-teal-50 to-cyan-100 dark:from-emerald-900/20 dark:via-teal-900/10 dark:to-cyan-900/20 rounded-2xl" />
            <img
              src={image}
              alt="Globe PVT Benefits"
              className="relative w-full h-auto rounded-2xl shadow-xl"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
}
